class NumberHelper {
  public numberWithCommas(value: number) {
    const parts = value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
  }

  /**
   * To Format a number
   * @param {Number} numberValue the number's value to format
   * @param {Number} decimals the number of decimal at the decimal [optional]
   * @param {String} dec_point the decimal point [optional]
   * @param {String} thousands_sep the thousands separator [optional]
   * @returns {String} Number formated
   */
  public numberFormat(
    numberValue: any,
    decimals?: any,
    decPoint?: any,
    thousandsSep?: any
  ) {
    numberValue = numberValue * 1;
    decimals = typeof decimals !== 'undefined' ? decimals : 2;
    decPoint = typeof decPoint !== 'undefined' ? decPoint : ',';
    thousandsSep = typeof thousandsSep !== 'undefined' ? thousandsSep : ' ';

    const parts = Number.parseFloat(numberValue)
      .toFixed(decimals)
      .toString()
      .split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

    return parts.join(decPoint);
  }

  /**
   * Parse number
   * @param {Number} value
   * @param {Number} decimalPoint
   */
  public parseToFloat(value: number, decimalPoint?: number): number {
    if (!decimalPoint) decimalPoint = 2;
    return parseFloat(Number(value).toFixed(decimalPoint));
  }

  /**
   * Parse number
   * @param {Number} value
   */
  public parseToInt(value: number): number {
    return parseInt(Number(value).toFixed(0));
  }
}

export default new NumberHelper();
